import React from "react";
import { Form } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Email template, footer, and signature selector component
 */
const EmailTemplateSelector = ({
  // Template props
  template,
  templateOptions,
  onTemplateChange,
  loading = false,

  // Footer props
  footerOptions,
  onFooterChange,

  // Signature props
  signatureOptions,
  onSignatureChange,
}) => {
  return (
    <Form.Group widths="equal">
      <Form.Select
        selectOnBlur={false}
        search
        required
        label="Email Template"
        value={template?.id || null}
        options={templateOptions}
        placeholder="Select a Template"
        onChange={onTemplateChange}
        loading={loading}
        error={templateOptions.length === 0 ? "No templates available" : null}
      />
      <Form.Select
        selectOnBlur={false}
        clearable
        label="Email Footer"
        placeholder="Select an Email Footer"
        onChange={onFooterChange}
        options={footerOptions}
      />
      <Form.Select
        selectOnBlur={false}
        clearable
        label="Email Signature"
        placeholder="Select an Email Signature"
        onChange={onSignatureChange}
        options={signatureOptions}
      />
    </Form.Group>
  );
};

EmailTemplateSelector.propTypes = {
  template: PropTypes.object,
  templateOptions: PropTypes.array.isRequired,
  onTemplateChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  footerOptions: PropTypes.array.isRequired,
  onFooterChange: PropTypes.func.isRequired,
  signatureOptions: PropTypes.array.isRequired,
  onSignatureChange: PropTypes.func.isRequired,
};

export default EmailTemplateSelector;
